export default function makeAndHandleRequest(query) {
  return fetch(`/api/search?q=${encodeURIComponent(query)}`)
    .then(resp => resp.json());
}



// WEBPACK FOOTER //
// ./src/util/makeAndHandleRequest.js